<template>
  <div
    class="flex justify-center items-center px-6 lg:px-3 xl:px-2 py-1 border rounded-full whitespace-nowrap max-w-xxs"
    :class="`${borderClass} text-${color}-700 h-${height}`"
  >
    <h6 class="px-2">{{ text }}</h6>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },

    color: {
      type: String,
      default: 'gray',
    },

    height: {
      type: Number,
      default: 6,
    },
  },

  computed: {
    borderClass() {
      const color = this.color
      if (color === 'red') {
        return `border-${color}-300`
      }
      if (color === 'green') {
        return `border-${color}-600`
      }
      return `border-gray-500`
    },
  },
}
</script>
